import { z } from 'zod';

export const ConflictKindSchema = z.enum([
  'unchanged',
  'added_remote',
  'removed_remote',
  'changed_remote',
  'local_only',
  'both_changed',
]);
export type ConflictKind = z.infer<typeof ConflictKindSchema>;

/** Canonieke regelvorm (zoals gebruikt voor hashing en diff). */
export const CanonicalLineSchema = z.object({
  key: z.string(),
  componentCode: z.string(),
  componentUnit: z.string().nullable(),
  qty: z.number(),
  per: z.number(),
  loss: z.number(),
  lineNumber: z.number().nullable(),
  description: z.string().nullable().optional(),
});
export type CanonicalLine = z.infer<typeof CanonicalLineSchema>;

export const ConflictLineSchema = z.object({
  key: z.string(),
  kind: ConflictKindSchema,
  base: CanonicalLineSchema.nullable(),
  remote: CanonicalLineSchema.nullable(),
  local: CanonicalLineSchema.nullable(),
  /** afwijkende velden tussen local en remote */
  fields: z.array(z.string()),
  suggested: z.enum(['unit4', 'local']).nullable(),
  /** id van de lokale regel (indien aanwezig) */
  localLineId: z.number().int().nullable(),
});
export type ConflictLine = z.infer<typeof ConflictLineSchema>;

export const ConflictReportSchema = z.object({
  productId: z.number().int(),
  hasConflict: z.boolean(),
  snapshotHash: z.string().nullable(),
  remoteHash: z.string(),
  localHash: z.string(),
  productFields: z.array(
    z.object({
      field: z.string(),
      base: z.unknown(),
      remote: z.unknown(),
      local: z.unknown(),
      suggested: z.enum(['unit4', 'local']).nullable(),
    }),
  ),
  orderChanged: z.boolean(),
  lines: z.array(ConflictLineSchema),
  requiredChoices: z.number().int(),
  fetchedAt: z.string(),
});
export type ConflictReport = z.infer<typeof ConflictReportSchema>;

export const ResolveBodySchema = z.object({
  choices: z.record(z.enum(['local', 'unit4'])).default({}),
  all: z.enum(['local', 'unit4']).optional(),
  productFields: z.record(z.enum(['local', 'unit4'])).optional(),
});
export type ResolveBody = z.infer<typeof ResolveBodySchema>;
